import React from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import ArrowLeftIcon from 'app/components/SVGS/ArrowLeftIcon'

import './styles.scss'
const bc = 'notifications-header'

const NotificationsHeader = ({ t }) => (
  <div className={bc}>
    <Link to={'/dashboard'} className={`${bc}__button`}>
      <ArrowLeftIcon />
      <span className={`${bc}__text`}>{t('Back')}</span>
    </Link>
    <div className={`${bc}__title`}>{t('Notifications')}</div>
  </div>
)

export default withTranslation()(NotificationsHeader)
